/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import MediumTypeLibrary from 'medium-type';

// TODO Hotfix neopravených bugů pomocí extends na knihovně.
/**
 * Media type.
 * Also known as MIME type or content type.
 *
 * Specification:
 * [RFC 2045](https://tools.ietf.org/html/rfc2045),
 * [RFC 2616](https://tools.ietf.org/html/rfc2616#section-14),
 * [RFC 3023](https://tools.ietf.org/html/rfc3023),
 * [RFC 6657](https://tools.ietf.org/html/rfc6657),
 * [RFC 6838](https://tools.ietf.org/html/rfc6838),
 * [RFC 6839](https://tools.ietf.org/html/rfc6839),
 * [RFC 7231](https://tools.ietf.org/html/rfc7231).
 *
 * Based on [medium-type](https://github.com/moll/js-medium-type) library.
 */
class MediumType extends MediumTypeLibrary {
  /**
   * Creates a new instance.
   * @param {ConstructorParameters<typeof MediumTypeLibrary>[0]} type Media type.
   */
  constructor(type) {
    // TODO Oprava dosud neopraveného bugu s parsováním undefined.
    // - https://github.com/moll/js-medium-type/issues/4
    if (type === undefined) {
      throw new SyntaxError(`Invalid Media Type: ${type}`);
    }
    super(type);
    // TODO Nemělo by být podporováno, ale plugin to neřeší.
    // - https://github.com/moll/js-medium-type/issues/1
    if (this.type === '*' && this.subtype !== '*') {
      throw new SyntaxError(`Invalid top-level type range: ${type}`);
    }
  }

  /**
   * Check for the strict equality with another media type.
   * @param {MediumType} mediumType Media type to check for equality.
   * @returns {boolean} True if both media types are equal in all of their parts.
   */
  equals(mediumType) {
    // TODO Přidáno porovnání striktní rovnosti typů (bez rozsahů).
    // - Mělo by být součástí knihovny.
    // - Naivní zpracování, bez důkladnějšího ošetření.
    // - https://github.com/moll/js-medium-type/issues/2
    return this.toString() === mediumType.toString();
  }
}

export default MediumType;
